export const fbqEventName = {
    onClick: 'Activate_This_Plan_Click',
    pending: {
        remote: 'Consultation_Pending',
        aayucard: 'Aayu_Card_Pending'
    },
    initialize: {
        remote: 'Consult_initiated',
        aayucard: 'Aayu_Card_Purchase_Initiated'
    },
    completion: {
        remote: 'Consultation_Done',
        aayucard: 'Aayu_Card_Purchased'
    },
}